import Facebook from "../../assets/icons/facebook.png";
import X from "../../assets/icons/x.png";
import Intsa from "../../assets/icons/instagram.png";
import Linkedin from "../../assets/icons/linkedin.png";
import WeChat from "../../assets/icons/wechat.svg";
import Whatsapp from "../../assets/icons/whatsapp.svg";


export const StaticIcons = {
  Facebook,
  X,
  Linkedin,
  Intsa,
  WeChat,
  Whatsapp
};